import { customerConfigurationValuesTypes } from "../../types";

export const initialCustomerValues: customerConfigurationValuesTypes = {
    chatGptEnabled:{
        "name": "chatGptEnabled",
        "type": "string",
        "value": false,
        "docUrl": "",
        "description": "",
        "possibleVals": [
          "string"
        ]
    },
    externalAppDeepLink:{
        "name": "externalAppDeepLink",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "",
        "possibleVals": [
          "string"
        ]
      },
    currencySymbol:{
        "name": "currencySymbol",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "currency Symbol",
        "possibleVals": [
        "string"
        ]
    },
    currency:{
        "name": "currency",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "currency Symbol",
        "possibleVals": [
        "string"
        ]
    },
    supportNumber:{
        "name": "supportNumber",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "support number",
        "possibleVals": [
        "string"
        ]
    },
    privacyLink:{
        "name": "privacyLink",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "privacylink",
        "possibleVals": [
        "string"
        ]
    },
    tncLink:{
        "name": "tncLink",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "tncLink",
        "possibleVals": [
        "string"
        ]
    },
    numberFormat:{
        "name": "numberFormat",
        "type": "string",
        "value": "",
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "This is the number format of the app  ",
        "possibleVals": [
        "en-US",
        "en-IN"
        ]
    },
    dialCode:{
        "name": "dialCode",
        "type": "string",
        "value": "",
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "This is the dial code of the country in which app is used .",
        "possibleVals": [
        "string"
        ]
    },
    countryCode:{
        "name": "countryCode",
        "type": "string",
        "value": "",
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "The country code of the country in which app is being used.",
        "possibleVals": [
        "string"
        ]
    },
    clientTimeZone:{
        "name": "clientTimeZone",
        "type": "string",
        "value": "",
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "The time zone format of the app.",
        "possibleVals": [
        "string"
        ]
    },
    activeLanguageColor:{
        "name": "activeLanguageColor",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "active language color",
        "possibleVals": [
        "string"
        ]
    }
}